"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPPORTUNITY_SORT_FIELDS = exports.OPPORTUNITY_NOTES_MAX_LENGTH = exports.DISMISSAL_DURATIONS = exports.OPPORTUNITY_STATUSES = exports.LEGACY_PRODUCT_TYPE_TO_FIG_PRODUCT_TYPE = exports.FIG_PRODUCT_TYPES = void 0;
exports.isProductType = isProductType;
exports.normalizeProductType = normalizeProductType;
// ============================================================================
// POLICY TYPES
// ============================================================================
exports.FIG_PRODUCT_TYPES = [
    'Annuity',
    'Deferred Income Annuity',
    'Fixed Annuity Products',
    'Fixed Immediate Annuity',
    'Fixed Indexed Annuity',
    'Indexed Annuity',
    'Registered Indexed Annuity',
    'Single Premium Immediate Annuity',
    'Unknown',
    'Variable Annuity Products',
    'Variable Immediate Annuity',
    'Variable Indexed Annuity',
];
const FIG_PRODUCT_TYPE_SET = new Set(exports.FIG_PRODUCT_TYPES);
exports.LEGACY_PRODUCT_TYPE_TO_FIG_PRODUCT_TYPE = {
    FIA: 'Fixed Indexed Annuity',
    MYGA: 'Fixed Annuity Products',
    VA: 'Variable Annuity Products',
    Fixed: 'Fixed Annuity Products',
    VIA: 'Variable Indexed Annuity',
    RILA: 'Registered Indexed Annuity',
    'Fixed Annuity': 'Fixed Annuity Products',
    'Variable Annuity': 'Variable Annuity Products',
};
function isProductType(value) {
    return typeof value === 'string' && FIG_PRODUCT_TYPE_SET.has(value);
}
function normalizeProductType(value) {
    const trimmed = value?.trim();
    if (!trimmed)
        return 'Unknown';
    if (isProductType(trimmed))
        return trimmed;
    const legacyMatch = Object.entries(exports.LEGACY_PRODUCT_TYPE_TO_FIG_PRODUCT_TYPE).find(([legacy]) => legacy.toUpperCase() === trimmed.toUpperCase());
    if (legacyMatch)
        return legacyMatch[1];
    const upper = trimmed.toUpperCase();
    if (upper.includes('REGISTERED') && upper.includes('INDEX')) {
        return 'Registered Indexed Annuity';
    }
    if (upper.includes('VARIABLE') && upper.includes('INDEX')) {
        return 'Variable Indexed Annuity';
    }
    if (upper.includes('VARIABLE')) {
        return 'Variable Annuity Products';
    }
    if (upper.includes('SINGLE PREMIUM') && upper.includes('IMMEDIATE')) {
        return 'Single Premium Immediate Annuity';
    }
    if (upper.includes('DEFERRED') && upper.includes('INCOME')) {
        return 'Deferred Income Annuity';
    }
    if (upper.includes('IMMEDIATE')) {
        return 'Fixed Immediate Annuity';
    }
    if (upper.includes('FIXED') && upper.includes('INDEX')) {
        return 'Fixed Indexed Annuity';
    }
    if (upper.includes('INDEX')) {
        return 'Indexed Annuity';
    }
    if (upper.includes('FIXED')) {
        return 'Fixed Annuity Products';
    }
    return 'Unknown';
}
// ============================================================================
// OPPORTUNITY TYPES
// ============================================================================
exports.OPPORTUNITY_STATUSES = ['new', 'actioned', 'dismissed', 'withdrawn'];
exports.DISMISSAL_DURATIONS = ['3_months', '6_months', '1_year', 'never'];
/** Maximum stored length of an opportunity note. */
exports.OPPORTUNITY_NOTES_MAX_LENGTH = 4000;
exports.OPPORTUNITY_SORT_FIELDS = [
    'propensity_score',
    'estimated_value',
    'scored_at',
    'account_value',
    'surrender_loss',
    'carrier_name',
    'agent_name',
    'client_age',
    'surrender_date',
    'sales_team_name',
    'client_name',
    'policy_number',
    'income_benefit_value',
    'tax_qualification',
    'forwarded_at',
    'forwarded_by',
    'status',
    'has_notes',
];
//# sourceMappingURL=models.js.map